export default "__VITE_ASSET__DIcCx6X1__"